import React from 'react'
import {useSelector} from 'react-redux'
import {getOfferTokenParam} from 'modules/accommodation/utils'
import {
  getPaymentSettings,
  getPaymentSettingsParams
} from 'modules/paymentSettings/selectors'

import {getOfferPaymentMode} from '@vio/core/src/offer/business/offerPaymentMode'
import {useGetPaymentSettingsQuery} from '@vio/core/src/offer/services/paymentSettingsApi'
import {CancellationPenalty, Offer} from '@vio/core/src/offer/types/offer'
import {getPaymentSettingsParamsInput} from '@vio/core/src/offer/utils/paymentSettings'
import {PaymentMethods as SharedPaymentMethods} from '@vio/shared/src/booking/DealDetails/PaymentMethods'

export const PaymentMethods = ({
  offer,
  bundleId,
  cancellationPenalties,
  bookingId
}: {
  cancellationPenalties: CancellationPenalty[]
  offer?: Offer
  bundleId?: string
  bookingId?: string
}) => {
  const isSplitBooking = Boolean(bundleId)
  const paymentMethodType = getOfferPaymentMode({offer, isSplitBooking})
  const offerToken: string | undefined = getOfferTokenParam(offer)
  const {id, idType} = getPaymentSettingsParamsInput({
    offerToken,
    bookingId,
    bundleId
  })
  const paymentOptionsParams = useSelector(state =>
    getPaymentSettingsParams(state, id, idType)
  )
  useGetPaymentSettingsQuery(paymentOptionsParams, {skip: !id})
  const {isComplete, supportedCards, availablePaymentMethods} = useSelector(
    state => getPaymentSettings(state, id, idType)
  )

  if (!isComplete) return null

  return (
    <SharedPaymentMethods
      supportedCards={supportedCards}
      availablePaymentMethods={availablePaymentMethods}
      paymentMethodType={paymentMethodType}
      cancellationPenalties={cancellationPenalties}
    />
  )
}
